import React, { useEffect, useState } from "react";
import {
    Card,
    Row,
    Col,
    Badge,
    Carousel,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";

export default function ViewReligiousAffiliation() {
    const { id } = useParams();

    const [affiliation, setAffiliation] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const AuthToken = localStorage.getItem("AuthUser");

    axios.defaults.headers.common[
        "Authorization"
    ] = `Bearer ${AuthToken}`;

    useEffect(() => {
        fetchAffiliation();
    }, []);

    const fetchAffiliation = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/religious-affiliations/${id}`
            );

            setAffiliation(res.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    if (!affiliation) {
        return (
            <PageLayout>
                <Card>
                    <Card.Body>Loading...</Card.Body>
                </Card>
            </PageLayout>
        );
    }

    return (
        <PageLayout>
            <Card>
                <Card.Header>
                    <h5 className="mb-0">
                        Religious Affiliation Details
                    </h5>
                </Card.Header>

                <Card.Body>
                    <Row>

                        {/* Family */}
                        <Col md={6}>
                            <p>
                                <strong>Family ID:</strong>{" "}
                                {affiliation.person?.f_number || "-"}
                            </p>
                        </Col>

                        {/* Person */}
                        <Col md={6}>
                            <p>
                                <strong>Person:</strong>{" "}
                                {affiliation.person?.beneficiary_name ||

                                    "-"}
                            </p>
                        </Col>

                        {/* Relation */}


                        {/* Faith */}
                        <Col md={6}>
                            <p>
                                <strong>Faith:</strong>{" "}
                                {affiliation.place?.faith?.name || "-"}
                            </p>
                        </Col>

                        {/* Prayer Place */}
                        <Col md={6}>
                            <p>
                                <strong>Prayer Place:</strong>{" "}
                                {
                                    affiliation.place?.palace_name ||
                                    "-"}
                            </p>
                        </Col>

                        {/* Master */}
                        <Col md={6}>
                            <p>
                                <strong>Master:</strong>{" "}
                                {
                                    affiliation.place?.master ||
                                    "-"}
                            </p>
                        </Col>

                        {/* Address */}
                        <Col md={12}>
                            <p>
                                <strong>Prayer Place Address:</strong>{" "}
                                {affiliation.place?.address ||

                                    "-"}
                            </p>
                        </Col>

                        {/* Baptized */}
                        {
                            affiliation.place?.fath_id === 2 && (
                                <Col md={6}>
                                    <p>
                                        <strong>Baptized:</strong>{" "}

                                        {Number(affiliation.baptized) === 1 ? (
                                            <Badge bg="success">
                                                Yes
                                            </Badge>
                                        ) : (
                                            <Badge bg="secondary">
                                                No
                                            </Badge>
                                        )}
                                    </p>
                                </Col>)}

                        {/* Comments */}
                        <Col md={12} className="mt-2">
                            <p>
                                <strong>Comments:</strong>
                            </p>

                            <div className="border p-3 rounded">
                                {affiliation.comments || "-"}
                            </div>
                        </Col>

                        {/* Gallery */}
                        {affiliation?.images?.length > 0 && (
                            <Col md={12} className="mt-5">
                                <h6 className="mb-3">
                                    Picture Gallery
                                </h6>

                                <Carousel
                                    activeIndex={activeIndex}
                                    onSelect={(selectedIndex) =>
                                        setActiveIndex(selectedIndex)
                                    }
                                    interval={null}
                                >
                                    {affiliation.images.map(
                                        (item) => (
                                            <Carousel.Item
                                                key={item.id}
                                            >
                                                <img
                                                    src={`${process.env.REACT_APP_IMG_URL}${item.img}`}
                                                    className="d-block w-100"
                                                    style={{
                                                        height: "500px",
                                                        objectFit: "contain",
                                                    }}
                                                    alt=""
                                                />
                                            </Carousel.Item>
                                        )
                                    )}
                                </Carousel>

                                {/* Gallery thumbnails */}
                                <div className="d-flex gap-2 mt-3 flex-wrap justify-content-center">
                                    {affiliation?.images.map(
                                        (item, index) => (
                                            <img
                                                key={item.id}
                                                src={`${process.env.REACT_APP_IMG_URL}${item.img}`}
                                                alt=""
                                                onClick={() =>
                                                    setActiveIndex(index)
                                                }
                                                style={{
                                                    width: "80px",
                                                    height: "80px",
                                                    objectFit: "cover",
                                                    cursor: "pointer",
                                                    border:
                                                        activeIndex === index
                                                            ? "3px solid #0d6efd"
                                                            : "1px solid #ddd",
                                                    borderRadius: "5px",
                                                }}
                                            />
                                        )
                                    )}
                                </div>
                            </Col>
                        )}

                        {/* Video */}
                        {affiliation.video_link && (
                            <Col
                                xs={12}
                                className="mt-5"
                            >
                                <h6>
                                    Religious Affiliation Video
                                </h6>

                                <div
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        paddingTop: "56.25%",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        background: "#000",
                                    }}
                                >
                                    <video
                                        controls
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                        }}
                                    >
                                        <source
                                            src={`${process.env.REACT_APP_IMG_URL}/${affiliation.video_link}`}
                                            type="video/mp4"
                                        />

                                        Your browser does not
                                        support the video tag.
                                    </video>
                                </div>
                            </Col>
                        )}

                    </Row>
                </Card.Body>
            </Card>
        </PageLayout>
    );
}

